export default __webpack_public_path__ + "static/media/location.590a9f81.svg";